import React from 'react';

function SpeechBalloonIcon({ width = 19, height = 18, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 19 18">
      <g>
        <path d="M14,16.2928932 L14,13.5 C14,13.2238576 14.2238576,13 14.5,13 L16.5,13 C17.3284271,13 18,12.3284271 18,11.5 L18,2.5 C18,1.67157287 17.3284271,1 16.5,1 L2.5,1 C1.67157287,1 1,1.67157287 1,2.5 L1,11.5 C1,12.3284271 1.67157287,13 2.5,13 L10.5,13 C10.6326082,13 10.7597852,13.0526784 10.8535534,13.1464466 L14,16.2928932 Z M10.2928932,14 L2.5,14 C1.11928813,14 0,12.8807119 0,11.5 L0,2.5 C0,1.11928813 1.11928813,0 2.5,0 L16.5,0 C17.8807119,0 19,1.11928813 19,2.5 L19,11.5 C19,12.8807119 17.8807119,14 16.5,14 L15,14 L15,17.5 C15,17.9454524 14.461429,18.1685358 14.1464466,17.8535534 L10.2928932,14 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default SpeechBalloonIcon;
